import { useState, useEffect } from 'react'

const CITIES = [
  { value: 'paris', label: 'Paris' },
  { value: 'lyon', label: 'Lyon' },
  { value: 'marseille', label: 'Marseille' },
  { value: 'toulouse', label: 'Toulouse' },
  { value: 'nice', label: 'Nice' },
  { value: 'nantes', label: 'Nantes' },
  { value: 'strasbourg', label: 'Strasbourg' },
  { value: 'montpellier', label: 'Montpellier' },
  { value: 'bordeaux', label: 'Bordeaux' },
  { value: 'lille', label: 'Lille' },
  { value: 'rennes', label: 'Rennes' },
  { value: 'reims', label: 'Reims' },
  { value: 'le-havre', label: 'Le Havre' },
  { value: 'saint-etienne', label: 'Saint-Étienne' },
  { value: 'toulon', label: 'Toulon' },
  { value: 'grenoble', label: 'Grenoble' },
  { value: 'dijon', label: 'Dijon' },
  { value: 'angers', label: 'Angers' },
  { value: 'nimes', label: 'Nîmes' },
  { value: 'villeurbanne', label: 'Villeurbanne' },
  { value: 'clermont-ferrand', label: 'Clermont-Ferrand' },
  { value: 'aix-en-provence', label: 'Aix-en-Provence' },
  { value: 'brest', label: 'Brest' },
  { value: 'tours', label: 'Tours' },
  { value: 'amiens', label: 'Amiens' },
  { value: 'limoges', label: 'Limoges' },
  { value: 'perpignan', label: 'Perpignan' },
  { value: 'metz', label: 'Metz' },
  { value: 'besancon', label: 'Besançon' },
  { value: 'orleans', label: 'Orléans' },
  { value: 'rouen', label: 'Rouen' },
  { value: 'mulhouse', label: 'Mulhouse' },
  { value: 'caen', label: 'Caen' },
  { value: 'nancy', label: 'Nancy' },
  { value: 'argenteuil', label: 'Argenteuil' },
  { value: 'montreuil', label: 'Montreuil' },
  { value: 'roubaix', label: 'Roubaix' },
  { value: 'tourcoing', label: 'Tourcoing' },
  { value: 'avignon', label: 'Avignon' },
  { value: 'creteil', label: 'Créteil' },
  { value: 'poitiers', label: 'Poitiers' },
  { value: 'versailles', label: 'Versailles' },
  { value: 'pau', label: 'Pau' },
  { value: 'la-rochelle', label: 'La Rochelle' },
  { value: 'antibes', label: 'Antibes' },
  { value: 'boulogne-billancourt', label: 'Boulogne-Billancourt' },
  { value: 'cannes', label: 'Cannes' },
  { value: 'merignac', label: 'Mérignac' },
  { value: 'colombes', label: 'Colombes' },
  { value: 'saint-denis', label: 'Saint-Denis' },
]

const PROPERTY_TYPES = [
  { value: '', label: 'Tous types' },
  { value: 'Appartement', label: 'Appartement' },
  { value: 'Maison', label: 'Maison / Villa' },
  { value: 'Terrain', label: 'Terrain' },
  { value: 'Parking', label: 'Parking' },
]

const TRANSACTION_TYPES = [
  { value: '', label: 'Vente & Location' },
  { value: 'Vente', label: 'Vente' },
  { value: 'Location', label: 'Location' },
]

const ROOMS_OPTIONS = [
  { value: '', label: 'Toutes' },
  { value: '1', label: '1 pièce +' },
  { value: '2', label: '2 pièces +' },
  { value: '3', label: '3 pièces +' },
  { value: '4', label: '4 pièces +' },
  { value: '5', label: '5 pièces +' },
]

// 1 crédit par page scrapée
const NB_PAGES_OPTIONS = [
  { value: '1', label: '1 page  (~20 annonces)', credits: 1 },
  { value: '2', label: '2 pages (~40 annonces)', credits: 2 },
  { value: '3', label: '3 pages (~60 annonces)', credits: 3 },
  { value: '4', label: '4 pages (~80 annonces)', credits: 4 },
  { value: '5', label: '5 pages (~100 annonces)', credits: 5 },
]

const inputStyle = {
  background: 'rgb(var(--rgb-ink) / 0.05)',
  border: '1px solid rgb(var(--rgb-ink) / 0.12)',
  borderRadius: 8,
  padding: '8px 12px',
  color: 'var(--color-text)',
  fontSize: 13,
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
}

const selectStyle = {
  ...inputStyle,
  background: '#1a1a2e',
}

const labelStyle = {
  fontSize: 11,
  color: 'rgb(var(--rgb-ink) / 0.45)',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  marginBottom: 4,
  display: 'block',
}

export default function ImmobilierSearchBox({ onSearch, loading, relaunchData }) {
  const [isExpanded, setIsExpanded] = useState(true)
  const [showAdvanced, setShowAdvanced] = useState(false)
  const [form, setForm] = useState({
    propertyType: '',
    transactionType: '',
    location: '',
    nbPages: '2',
    priceMin: '',
    priceMax: '',
    surfaceMin: '',
    surfaceMax: '',
    roomsMin: '',
    dateFrom: '',
    dateTo: '',
  })

  useEffect(() => {
    if (!relaunchData) return
    setIsExpanded(true)
    setShowAdvanced(false)
    setForm({
      propertyType: relaunchData.propertyType ?? '',
      transactionType: relaunchData.transactionType ?? '',
      location: relaunchData.location ?? '',
      nbPages: relaunchData.nbPages
        ? String(relaunchData.nbPages)
        : relaunchData.quantity
          ? String(Math.min(5, Math.max(1, Math.ceil(relaunchData.quantity / 20))))
          : '2',
      priceMin: relaunchData.priceMin != null ? String(relaunchData.priceMin) : '',
      priceMax: relaunchData.priceMax != null ? String(relaunchData.priceMax) : '',
      surfaceMin: relaunchData.surfaceMin != null ? String(relaunchData.surfaceMin) : '',
      surfaceMax: relaunchData.surfaceMax != null ? String(relaunchData.surfaceMax) : '',
      roomsMin: relaunchData.roomsMin != null ? String(relaunchData.roomsMin) : '',
      dateFrom: relaunchData.dateFrom ?? '',
      dateTo: relaunchData.dateTo ?? '',
    })
  }, [relaunchData])

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.location) return
    const city = CITIES.find(c => c.value === form.location)
    const filters = {}
    if (form.propertyType) filters.propertyType = form.propertyType
    if (form.transactionType) filters.transactionType = form.transactionType
    filters.location = form.location
    filters.locationLabel = city?.label ?? form.location
    filters.nbPages = parseInt(form.nbPages) || 2
    if (form.priceMin) filters.priceMin = parseFloat(form.priceMin)
    if (form.priceMax) filters.priceMax = parseFloat(form.priceMax)
    if (form.surfaceMin) filters.surfaceMin = parseFloat(form.surfaceMin)
    if (form.surfaceMax) filters.surfaceMax = parseFloat(form.surfaceMax)
    if (form.roomsMin) filters.roomsMin = parseInt(form.roomsMin)
    if (form.dateFrom) filters.dateFrom = form.dateFrom
    if (form.dateTo) filters.dateTo = form.dateTo
    onSearch(filters)
  }

  const handleCancel = () => {
    setIsExpanded(false)
    setShowAdvanced(false)
    setForm({ propertyType: '', transactionType: '', location: '', nbPages: '2', priceMin: '', priceMax: '', surfaceMin: '', surfaceMax: '', roomsMin: '', dateFrom: '', dateTo: '' })
  }

  const nbPages = parseInt(form.nbPages) || 2
  const creditCost = nbPages

  const selectedCity = CITIES.find(c => c.value === form.location)

  const summaryParts = [
    form.transactionType && TRANSACTION_TYPES.find(t => t.value === form.transactionType)?.label,
    form.propertyType && PROPERTY_TYPES.find(t => t.value === form.propertyType)?.label,
    selectedCity && `à ${selectedCity.label}`,
    form.priceMax && `max ${Number(form.priceMax).toLocaleString()}€`,
    form.surfaceMin && `min ${form.surfaceMin}m²`,
    form.roomsMin && `${form.roomsMin}p+`,
  ].filter(Boolean)

  return (
    <div className="inline-search-box" style={{ order: -1 }}>
      <p className="search-hint">Scrapez des annonces immobilières en temps réel</p>

      {!isExpanded && (
        <div className="search-collapsed">
          <button className="minimal-search-btn" onClick={() => setIsExpanded(true)} type="button">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            <span>Rechercher des biens immobiliers...</span>
            <kbd className="kbd-hint">⌘K</kbd>
          </button>
        </div>
      )}

      {isExpanded && (
        <form onSubmit={handleSubmit} className="search-expanded">
          {/* Ligne 1 — type de bien + type transaction + localisation */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
            <div>
              <label style={labelStyle}>Type de bien</label>
              <select name="propertyType" value={form.propertyType} onChange={handleChange} style={selectStyle}>
                {PROPERTY_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Transaction</label>
              <select name="transactionType" value={form.transactionType} onChange={handleChange} style={selectStyle}>
                {TRANSACTION_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Ville <span style={{ color: 'rgba(255,60,60,0.7)' }}>*</span></label>
              <select name="location" value={form.location} onChange={handleChange} style={selectStyle} required>
                <option value="">— Choisir une ville —</option>
                {CITIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            </div>
          </div>

          {/* Ligne 2 — nb pages + prix + surface + pièces */}
          <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr 1fr 1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
            <div>
              <label style={labelStyle}>
                Pages scrapées
                <span style={{ marginLeft: 6, color: 'rgba(91, 92, 244,0.6)', fontWeight: 700 }}>
                  {creditCost} crédit{creditCost > 1 ? 's' : ''}
                </span>
              </label>
              <select name="nbPages" value={form.nbPages} onChange={handleChange} style={{ ...selectStyle, borderColor: 'rgba(91, 92, 244,0.25)' }}>
                {NB_PAGES_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Prix min (€)</label>
              <input name="priceMin" type="number" min="0" value={form.priceMin} onChange={handleChange} placeholder="100 000" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Prix max (€)</label>
              <input name="priceMax" type="number" min="0" value={form.priceMax} onChange={handleChange} placeholder="500 000" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Surface min (m²)</label>
              <input name="surfaceMin" type="number" min="0" value={form.surfaceMin} onChange={handleChange} placeholder="40" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Surface max (m²)</label>
              <input name="surfaceMax" type="number" min="0" value={form.surfaceMax} onChange={handleChange} placeholder="200" style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Pièces min</label>
              <select name="roomsMin" value={form.roomsMin} onChange={handleChange} style={selectStyle}>
                {ROOMS_OPTIONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
            </div>
          </div>

          {/* Filtres avancés (dates) */}
          <button
            type="button"
            onClick={() => setShowAdvanced(!showAdvanced)}
            style={{ background: 'none', border: 'none', color: 'rgb(var(--rgb-ink) / 0.35)', fontSize: 12, cursor: 'pointer', padding: '2px 0', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 4 }}
          >
            {showAdvanced ? '▼' : '▶'} Filtres avancés (dates)
          </button>

          {showAdvanced && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10, padding: '12px', borderRadius: 8, background: 'rgb(var(--rgb-ink) / 0.03)', border: '1px solid rgb(var(--rgb-ink) / 0.07)' }}>
              <div>
                <label style={labelStyle}>Publiées depuis</label>
                <input name="dateFrom" type="date" value={form.dateFrom} onChange={handleChange} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Publiées jusqu'au</label>
                <input name="dateTo" type="date" value={form.dateTo} onChange={handleChange} style={inputStyle} />
              </div>
            </div>
          )}

          {/* Aperçu de la requête */}
          {form.location && (
            <div style={{ marginBottom: 10, padding: '8px 12px', borderRadius: 8, background: 'rgba(91, 92, 244,0.05)', border: '1px solid rgba(91, 92, 244,0.15)', fontSize: 12, color: 'rgb(var(--rgb-ink) / 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 6 }}>
              <span>
                <span style={{ color: 'rgba(91, 92, 244,0.8)', marginRight: 6 }}>Recherche :</span>
                <span style={{ fontStyle: 'italic' }}>
                  {summaryParts.length > 0 ? summaryParts.join(' · ') : selectedCity?.label}
                </span>
              </span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                <span style={{ color: 'rgb(var(--rgb-ink) / 0.3)' }}>{nbPages} page{nbPages > 1 ? 's' : ''}</span>
                <span style={{ color: 'rgba(91, 92, 244,0.7)', fontWeight: 700, background: 'rgba(91, 92, 244,0.1)', borderRadius: 4, padding: '2px 7px' }}>
                  {creditCost} crédit{creditCost > 1 ? 's' : ''}
                </span>
              </span>
            </div>
          )}

          <div className="search-actions">
            <button className="search-action-btn btn-secondary" type="button" onClick={handleCancel}>Annuler</button>
            <button
              className="search-action-btn btn-enrich"
              type="submit"
              disabled={loading || !form.location}
              style={{ background: 'rgba(91, 92, 244,0.15)', borderColor: 'rgba(91, 92, 244,0.4)', color: 'rgba(91, 92, 244,0.9)' }}
            >
              {loading ? 'Scraping...' : `Lancer le scraping (${creditCost} crédit${creditCost > 1 ? 's' : ''})`} <kbd>↵</kbd>
            </button>
          </div>
        </form>
      )}
    </div>
  )
}
